import styled from 'styled-components';
import { Button, Form } from 'antd';
import { breakpoints } from '../../../styles/breakpoints';

export const StyledFormItem = styled(Form.Item)`
  text-align: end;
  padding: 20px 0 0 0;
`;
